"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
var _index = _interopRequireDefault(require("@/components/reTitle/index"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    RealTitle: _index.default
  },
  data: function data() {
    return {
      titleContent: "作品简介",
      titleInfo: {
        sec: "历年作品展示",
        path: "/hisWorks"
      },
      // 作品集id
      worksId: '',
      // 推荐列表（该作品集下的所有作品）
      workList: [],
      // 当前展示作品
      work: {
        id: '',
        displayName: '',
        workName: '',
        contentFile: '',
        bureauName: '',
        categoryName: '',
        schoolName: ''
      },
      videoList: [{
        videoName: "当你的天空突然下起了大雨",
        videoSrc: "",
        imgSrc: ""
      }, {
        videoName: "当你的发丝微乱有阵风吹过",
        videoSrc: "",
        imgSrc: ""
      }, {
        videoName: "当前面太多阻碍看不到对岸",
        videoSrc: "",
        imgSrc: ""
      }, {
        videoName: "当你的发丝微乱有阵风吹过",
        videoSrc: "",
        imgSrc: ""
      }, {
        videoName: "当前面太多阻碍看不到对岸",
        videoSrc: "",
        imgSrc: ""
      }, {
        videoName: "当你的发丝微乱有阵风吹过",
        videoSrc: "",
        imgSrc: ""
      }, {
        videoName: "当前面太多阻碍看不到对岸",
        videoSrc: "",
        imgSrc: ""
      }],
      videoInfo: {
        videoUrl: "",
        videoTile: "多少有点抽象了呀",
        education: "广东省教育局",
        school: "广东省抽象艺术学院",
        group: '"最美班主任"组',
        fileType: "mp4"
      }
    };
  },
  mounted: function mounted() {
    if (this.$route.query && this.$route.query.id) {
      this.worksId = this.$route.query.id;
    }
    this.getAllWorks();
  },
  watch: {
    worksId: function worksId() {
      var _this = this;
      this.work = this.workList.find(function (item) {
        return item.id === _this.worksId;
      });
    }
  },
  methods: {
    // 点击推荐作品时
    switchWork: function switchWork(e) {
      this.worksId = e.id;
    },
    // 通过作品集id得到所有作品
    getAllWorks: function getAllWorks() {
      // request({
      //   url:'show/viewWorks',
      //   data:{
      //     id:this.worksId
      //   },
      //   type:'postQs'
      // }).then(res=>{
      //   this.workList = res.data.data
      //   this.work = res.data.data[0]
      //   console.log(this.workList);
      // })
    },
    handleSizeChange: function handleSizeChange(val) {
      console.log("\u6BCF\u9875 ".concat(val, " \u6761"));
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: ".concat(val));
    }
  }
};